export const initialState = {
  checklist: {
    id: null,
    reqDocTypeId: null,
    documentName: '',
    sharePointContentType: '',
    mandatoryYN: false,
    defaultYN: false,
    filterCondition: '',
    targetAreaName: '',
    changed: false
  }
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    default:
      return state;
  }
}

function onHeaderSaved(state, action) {
  const { id } = action;
  return {
    ...state,
    checklist: {
      ...state.checklist,
      id: id,
      changed: false
    }
  };
}

function onInitState(state, action) {
  // eslint-disable-next-line no-unused-vars
  const { filterCondition, requiredDocumentFilters, requiredDocumentProperties, ...requiredDocument } = action.data;
  return {
    ...state,
    checklist: { ...requiredDocument, changed: false }
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    checklist: {
      ...state.checklist,
      [propertyName]: value,
      changed: true
    }
  };
}
